import { ScreenSize, ImageGeometry } from 'ha/modules/UI/constants';

export const LOAD_LISTING_QUERY = `
  query _ ($id: Int!, $imagesGeometry: String!) {
    me {
      lastMessage {
        message
      }
    }
    listing(id: $id) {
      entityId
      advertiser {
        entityId
        avatarURL
        birthDate
        completedBookingsCount
        countryCode
        description
        firstName
        hasFacebookProfile
        hasPhone
        hasPaymentMethod
        isEmailVerified
        lastActivityAt
        listingsCount
        location
        registeredSince
        responseRate
        responseTime
        spokenLanguages
        study
        work
        uniID
        isTrusted
      }
      preferredTenant {
        couplesAllowed
        gender
        maxAge
        minAge
        status
      }
      searchURL {
        cityPath
        name
        path
      }
      belongsToPartner
      city
      cityLocalized
      country
      countryCode
      countryLocalized
      conversationLink
      currency
      currentOccupancy
      description
      startDate
      endDate
      estimatedBills
      facilities
      freePlaces
      agencyFee
      haFee
      baseHaFee
      deposit
      images: images(geometry: $imagesGeometry, crop: false)
      thumbnails: images(geometry: "tiny", crop: false)
      previewImage
      isDeleted
      isHidden
      isInstantAllowed
      kind
      lastMonthConversationsCount
      latitude
      longitude
      listingPath
      minimalRentalPeriod
      partnerRoomId
      price
      exclusions {
        from
        to
      }
      street
      type
    }
    similarListings(listingID: $id, limit: 4) {
      edges {
        node {
          id
          entityId
          kind
          type
          advertiser {
            avatarURL
          }
          city
          street
          startDate
          endDate
          previewImage
          price
          currency
          listingPath
          isNew
          facilities
          exclusions {
            from
            to
          }
          minimalRentalPeriod
        }
      }
    }
  }
`;

export const galleryOpenedEventName = 'Full screen gallery opened';

export const ACTION_PREFIX = 'LISTING_PAGE';
export const STATE_NAME = 'listing';
export const HOTJAR_TRIGGER_NAME = 'interaction_with_contact_advertiser_form';
export const HOTJAR_TAG_NAMES = [HOTJAR_TRIGGER_NAME];

export const Actions = {
  INITIALIZE: `${ACTION_PREFIX}/INITIALIZE`,
  INITIALIZE_QUERY_PARAMS: `${ACTION_PREFIX}/INITIALIZE_QUERY_PARAMS`,
  INITIALIZE_INSTANT_BOOKING: `${ACTION_PREFIX}/INITIALIZE_INSTANT_BOOKING`,
  INSTANT_BOOKING_CHECK: `${ACTION_PREFIX}/INSTANT_BOOKING_CHECK`,

  LOAD_LISTING_START: `${ACTION_PREFIX}/LOAD_LISTING_START`,
  LOAD_LISTING_DONE: `${ACTION_PREFIX}/LOAD_LISTING_DONE`,
  LOAD_LISTING_FAIL: `${ACTION_PREFIX}/LOAD_LISTING_FAIL`,

  LOAD_CITY_START: `${ACTION_PREFIX}/LOAD_CITY_START`,
  LOAD_CITY_DONE: `${ACTION_PREFIX}/LOAD_CITY_DONE`,
  LOAD_CITY_FAIL: `${ACTION_PREFIX}/LOAD_CITY_FAIL`,

  UPDATE_DESIRED_DATES: `${ACTION_PREFIX}/UPDATE_DESIRED_DATES`,

  DETECT_DESCRIPTION_LANGUAGE_START: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_START`,
  DETECT_DESCRIPTION_LANGUAGE_DONE: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_DONE`,
  DETECT_DESCRIPTION_LANGUAGE_FAIL: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_FAIL`,

  TRANSLATE_DESCRIPTION_START: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_START`,
  TRANSLATE_DESCRIPTION_DONE: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_DONE`,
  TRANSLATE_DESCRIPTION_FAIL: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_FAIL`,

  TOGGLE_DESCRIPTION_LANGUAGE: `${ACTION_PREFIX}/TOGGLE_DESCRIPTION_LANGUAGE`,

  SHOW_MODAL: `${ACTION_PREFIX}/SHOW_MODAL`,
  HIDE_MODAL: `${ACTION_PREFIX}/HIDE_MODAL`,

  UPDATE_LISTING: `${ACTION_PREFIX}/UPDATE_LISTING`,

  LOAD_BOOKABLE_PERIODS_START: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_START`,
  LOAD_BOOKABLE_PERIODS_DONE: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_DONE`,
  LOAD_BOOKABLE_PERIODS_FAIL: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_FAIL`,

  TOGGLE_FULLSCREEN_MAP: `${ACTION_PREFIX}/TOGGLE_FULLSCREEN_MAP`,

  SHOW_CONTACT_MODAL: `${ACTION_PREFIX}/SHOW_CONTACT_MODAL`,
};

export const GalleryImagesGeometry = {
  [ScreenSize.XS]: ImageGeometry.LARGE,
  [ScreenSize.SM]: ImageGeometry.LARGE,
  [ScreenSize.MD]: ImageGeometry.LARGE_RETINA,
  [ScreenSize.LG]: ImageGeometry.LARGE_RETINA,
  [ScreenSize.XL]: ImageGeometry.LARGE_RETINA,
};

export const Modals = {
  CONTACT: 'contact',
  ENRICH: 'enrich',
  SUCCESS: 'success',
  SUCCESS_CONTACT: 'successContact',
  UPDATED: 'updated',
};

export const LISTING_NOT_FOUND_ERROR_MESSAGE = 'Listing with that id not found';

export const INITIAL_MAP_ZOOM = 14;
